import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { H2, H3, Paragraph } from "BaseComponents/Text";

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${H2} {
    z-index: 1;
    margin: 0 2rem 0 0;
  }
  ${media.lessThan(breakpoints.mobile)`
	padding-right: 1rem;
	justify-content: space-between;
`}
`;
export const IconWrapper = styled.div.attrs(({ hoverColor, theme }) => ({
  hoverColor: hoverColor ? hoverColor : theme.colors.black,
}))`
  z-index: 1;
  a {
    i {
      transition: 0.2s ease;
    }
    margin-left: 0.5rem;

    &:hover {
      i {
        color: ${({ hoverColor }) => hoverColor};
        transition: 0.2s ease;
      }
    }
  }
`;
export const Icon = styled.i`
  font-size: 40px;
  color: ${({ theme }) => theme.colors.primary};
  &:before {
    margin: 0;
  }
  ${media.lessThan(breakpoints.mobile)`
	font-size: 32px;
	
	`}
`;

export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    transition: 0.4s ease;
    max-width: 80%;
  }
`;
export const CloseButton = styled.button`
  border: none;
  color: white;
  z-index: 10;
  background: transparent;
  i:before {
    font-size: 50px;
  }
  cursor: pointer;
`;
export const Modal = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.9);
  height: 100vh;
  width: 100%;
  transition: 0.2s ease;
  z-index: 9999999;
  top: 0;
  left: 0;

  img {
    position: relative;
    border-radius: ${({ theme }) => theme.border.radius};
    max-width: 950px;
    ${media.lessThan(breakpoints.ipad)`
		max-width: 90%;
		`}
  }
`;
export const ButtonWrapper = styled.div`
  position: absolute;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  right: 0;
  padding: 3rem;
  height: 50px;
  width: 50px;
`;
export const SlideShowWrapper = styled.div.attrs(({ bgColor, theme }) => ({
  bg: bgColor ? `#${bgColor}` : theme.colors.white,
  id: "SlideShowWrapper"
}))`
  background-color: ${({ bg }) => bg};
  position: relative;
  padding: 0 0rem;
  max-width: 85%;

  ${media.lessThan(breakpoints.ipad)`
  		padding: 1rem 1rem;
  	`}
  ${media.lessThan(breakpoints.mobile)`
	&:after {
		content: "";
		width: ${({ notFirstSlide }) => (notFirstSlide ? "10%" : "")};
		height: 100%;
		background: ${({ bg }) =>
      `linear-gradient(to left, rgb(255 255 255 / 0%) 0%, ${bg})`};
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		/* z-index: 1; */
	}
  		padding: 0;
  	`}

	 

	&:before {
    content: "";
    width: ${({ notFirstSlide }) => (!notFirstSlide ? "18%" : "10%")};
    height: 100%;
    background: ${({ bg }) =>
      `linear-gradient(to left, rgb(255 255 255 / 0%) 0%, ${bg})`};
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
  }

  ${media.greaterThan(breakpoints.mobile)`
        &:before {
            content: none;
        }
    `}
`;

export const SlideShowInnerWrapper = styled.div`
  max-width: ${({ theme }) => theme.grid.outer};
  padding: 3rem 0 3rem 1rem;
  width: auto;
  ${H2} {
    text-align: center;
  }

  ${media.greaterThan(breakpoints.mobile)`
        margin: 0 auto;
        padding: 3rem 0rem;
        width: auto;
    `}
`;

export const SliderWrapper = styled.div.attrs(({ justify }) => ({
  justify: justify ? justify : "flex-start",
}))`
  display: flex;
  flex-direction: row;
  margin-left: -10px;

  .slider-list {
    ${media.greaterThan(breakpoints.mobile)`

		margin-left: -10px;
		`}
    li:before {
      content: "";
    }
  }

  .slider-slide,
  .slider,
  .slider-list,
  .slider-frame {
    min-height: 300px;
    outline: none;
  }
  .slider-list {
    ${media.lessThan(breakpoints.mobile)`
		left: ${({ notFirstSlide }) => (notFirstSlide ? "8%" : "")};
		`}
  }

  .slider-control-bottomcenter {
    & > ul {
      top: 0 !important;
      ${media.lessThan(breakpoints.mobile)`
			display: ${({ showButtons }) => (showButtons ? "flex" : "none !important")};
			
			
			
			`}
    }
  }

  .slide-visible {
    /* margin-left: 0 !important; */

    &:before {
      content: none;
    }
  }

  .slide-current {
    & > div {
      /* margin-left: 0 !important; */
    }
  }
  .slider-list {
    ${media.greaterThan(breakpoints.ipad)``}

    transition: height 0.2s ease;
  }
  .paging-item {
    button {
      /* outline: none; */
      opacity: 1 !important;
      &[style] {
        fill: ${({ theme }) => theme.colors.white} !important;
      }
      svg {
        border: ${({ theme }) => `1px solid ${theme.colors.primary}`};
        border-radius: 100%;
        background-color: ${({ theme }) => theme.colors.white};
        width: 20px;
        height: 20px;
      }
    }
    &.active button[style] {
      fill: ${({ theme }) => `${theme.colors.secondary} !important`};
      svg {
        background-color: ${({ theme }) => theme.colors.secondary};
      }
    }
    &:before {
      content: none;
    }
  }

  ${media.greaterThan(breakpoints.mobile)`
        flex-wrap: wrap;
        justify-content: space-between;
    `}

  ${media.greaterThan(breakpoints.ipad)`
        flex-wrap: nowrap;
        & > div:first-of-type { margin-left: 0; }

    `}
    ${media.greaterThan(breakpoints.desktop)`
        justify-content: ${(props) => props.justify};
    `}
`;

export const ImageWrapper = styled.div`
  border: 1px solid #d0d0d0;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.border.radius};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% center;
  background-image: ${({ bgImage }) => `url(${bgImage})`};
  padding: 1rem;
  display: flex;
  flex-direction: column;
  width: auto;
  align-items: center;
  margin: 0.5rem;
  outline: none;
  transition: all 0.2s ease;
  cursor: pointer;
  /* min-height: 220px; */

  ${media.greaterThan(breakpoints.mobile)`
        margin: 1rem;
        flex-basis: calc(47% - 4rem);
        flex-grow: 1;
		
    `}

  &:before {
    content: "";
    display: block;
    width: 100%;
    padding-bottom: ${({ paddingBottom }) =>
      paddingBottom ? paddingBottom : "56.25%"};
    overflow: hidden;
  }

  ${media.greaterThan(breakpoints.ipad)`
    flex-basis: calc(25% - 4rem);
  `}

  &:hover, &:focus {
    border-color: ${({ theme }) => theme.colors.primary};

    ${H3} {
      transition: 0.2s ease;
      border-color: black;
    }
  }
`;
